import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell } from '@fortawesome/pro-solid-svg-icons';

import { IconButton } from '@mui/material'
import { NEWS_ROUTE } from '../../../constants/routes';
import { useNavigate } from 'react-router-dom';

export const NewsBellNavItem = () => {
    const navigate = useNavigate();

    return (
        <IconButton onClick={() => navigate(NEWS_ROUTE)} sx={{ p: 0, mr: '1.5rem' }}>
            <FontAwesomeIcon size='xs' icon={faBell} style={{ color: "#fff" }} />
        </IconButton>
    )
}

